

export const SOCIAL_CONFIG = {
  GOOGLE_CLIENT_ID: '804010865204-k6116okp376nmttf99v8v8mk50hmbl49.apps.googleusercontent.com',    // From Google Cloud Console
  FACEBOOK_CLIENT_ID: 'your_facebook_app_id',   // From Facebook Developers Console (App ID)
  APPLE_CLIENT_ID: 'your_apple_client_id'       // From Apple Developer Account
}; 